import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log(error.response?.data?.description);
    return {
      hasError: true,
      error:
        error.response?.data?.description ||
        error.response?.data ||
        error ||
        'erreur'
    };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error);
  }

  render() {
    let error = this.state.error;

    if (typeof this.state.error === 'string') {
      try {
        error = JSON.parse(this.state.error);
      } catch (error) {}
    }

    if (this.props.fallback && this.state.hasError) {
      return (
        <div className={`${this.props.className || ''}`}>
          {this.props.fallback}
        </div>
      );
    }
    if (this.state.hasError) {
      return (
        <div className={`${this.props.className || ''} alert--wrapper`}>
          <div className="alert alert--danger">
            {this.props.showErrorTitle && error?.title ? (
              <div className="mb-2 font-bold">{error.title}</div>
            ) : null}
            {this.props.hideDescription
              ? null
              : `Une erreur est survenue, veuillez réssayer. Si le problème
            persiste, n'hésitez pas à nous contacter.`}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
